var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBillingPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.83366 11.8307V0.164062H11.8337V11.8307H6.83366ZM0.166992 11.8307V0.164062H5.16699V11.8307H0.166992ZM8.50033 10.1641H10.167V1.83073H8.50033V10.1641ZM1.83366 10.1641H3.50033V1.83073H1.83366V10.1641Z",
    fill: "#7A7A7A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBillingPause);
export default __webpack_public_path__ + "static/media/icon-billing-pause.df9cd8c3801a6d1e6dd741fa35fac060.svg";
export { ForwardRef as ReactComponent };